
export const CURRENT_AWARENESS = 'ca'
export const CURRENT_AWARENESS_PREPAY = 'currentawarenessprepay'
export const CURRENT_AWARENESS_HOMEPAGE = 'currentawarenesshomepage'
export const CURRENT_AWARENESS_HOMEPAGE_ARTICLE = 'currentawarenesshomepagearticle'
export const CURRENT_AWARENESS_HOMEPAGE_ARTICLE_PREPAY = 'currentawarenesshomepagearticleprepay'
export const CURRENT_AWARENESS_ARTICLE = 'currentawarenessarticle'
export const CURRENT_AWARENESS_SEARCH = 'currentawarenesssearch'
export const CURRENT_AWARENESS_SEARCH_PREPAY = 'currentawarenesssearchprepay'
export const GUIDES = 'guides'
export const FEATURED_GUIDES = 'featuredguides'
export const PUBLISHED_CA_KEY_PICKS_PREPAY = 'publishedcakeypicksprepay'
export const PUBLISHED_CA_KEY_PICKS = 'publishedcakeypicks'
export const LEGISLATION_ACT = 'act'
export const LEGISLATION_ACTS = 'acts'
export const LEGISLATION_FOLDERS = 'legislationfolders'
export const LEGISLATION_REFERENCE = 'legislationreference'
export const LEGISLATION_RELATED_QAS = 'relatedqas'
export const LEGISLATION_SEARCH = 'legislationsearch'
export const LEGISLATION_SEARCH_PREPAY = 'legislationsearchprepay'
export const QA_CONTENT = 'content'
export const QA_CONTENT_PREPAY = 'contentprepay'
export const QA_INSTANTSEARCH = 'instantsearch'
export const QA_SEARCH = 'search'
export const QA_SEARCH_PREPAY = 'searchprepay'
export const QA_SECTIONS = 'sections'
export const QA_SECTIONS_PREPAY = 'sectionsprepay'
export const QA_REFERENCES = 'qarefs'
export const QA_ANSWERS = 'qaanswers'
export const CASE_REFS_CHAPTER = 'caserefschapter'
export const SEARCH_HISTORY = 'searchhistory'
export const TAKEOVER_CODE = 'takeover'
export const TAKEOVER_CODE_VERSIONS = 'takeoverversions'
export const TAKEOVER_CODE_COPY = 'takeovercopy'
export const TRACKING = 'tracking'
export const USER = 'user'
export const EMAIL_PREFERENCES = 'emailpreferences'
export const USER_AUTH = 'userauth'
export const DOCUMENTS = 'documents'
export const DOCUMENTS_PREPAY = 'documentsprepay'
export const DOCUMENTS_SEARCH = 'documentssearch'
export const DOCUMENTS_SEARCH_PREPAY = 'documentssearchprepay'
export const DOCUMENT_SECTIONS = 'documentsections'
export const AUTOMATED_DOCUMENTS = 'automateddocuments'
export const AUTOMATED_DOCUMENTS_PREPAY = 'automateddocumentsprepay'
export const CLARILIS_DOCUMENTS = 'clarilisdocuments'
export const CLARILIS_LINK = 'clarilislink'
export const CLARILIS_LINK_PREPAY = 'clarilislinkprepay'
export const CLARILIS_DOCS = 'clarilisdocs'
export const CLARILIS_DOCS_PREPAY = 'clarilisdocsprepay'
export const MW_EVENT_TYPES = 'mweventtypes'
export const MW_FEATURED_DEAL = 'mwfeatureddeal'
export const MW_STATS_SUMMARY = 'mwstatssummary'
export const MW_LATEST_DEALS = 'mwlatestdeals'
export const MW_EVENT_CONFIGURATION = 'mweventconfiguration'
export const MW_SHARED_EVENTS_CONFIGURATION = 'mwsharedeventsconfiguration'
export const MW_LIST_DEALS = 'mwlistdeals'
export const MW_STATS = 'mwstats'
export const MW_DEAL = 'mwdeal'
export const MW_DEAL_DOCUMENT = 'mwdealdocument'
export const FAVOURITES = 'favourites'
export const AOL_ORDER_PREFERENCES = 'aolorderpreferences'
export const PRIMARY_AOL = 'primaryaol'
export const PRACTISING_AOL = 'practisingaol'
